import {HttpHeaders} from "@angular/common/http"

export const getDefaultHttpHeaders = (): {headers: HttpHeaders } => {
  return {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  }
}
